
const {ccclass, property} = cc._decorator;

@ccclass
export default class CustomButton extends cc.Button {

    @property(cc.Label)
    label: cc.Label = null;

    @property
    text: string = 'hello';

    /**
     * 加载
     */
    onLoad() {
        // this.node._oldHitTest = this.node._hitTest.bind(this.node);
        // this.node._hitTest = this.polygonHitTest.bind(this.node);
    }
    /**
     * 不规则多边形触摸测试
     * @param {触摸点} point
     * @param {监听} listener
     */
    polygonHitTest(point, listener) {
        // var polygonCollider = this.getComponent(cc.PolygonCollider);
        // if (polygonCollider) {
        //     point = this.node.convertToNodeSpace(point);
        //     point.x -= this.node.getContentSize().width / 2;
        //     point.y -= this.node.getContentSize().height / 2;
        //     return cc.Intersection.pointInPolygon(point, polygonCollider.points);
        // } else {
        //     return this.node._oldHitTest(point, listener);
        // }
    }

}
